export default __webpack_public_path__ + "static/media/HBCH-USDT.b26af652.svg";